module.exports = __webpack_public_path__ + "static/img/car-maintenance-logo.9c2e384.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car-maintenance-logo.png
// module id = R+RH
// module chunks = 0